import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/pages/[slug]/page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/pages-bg.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/paper-bg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/redacted-black.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/tape-bg.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/app/src/components/carousel/Carousel.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/paper-box/PaperBox.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/pod-content/PodContent.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/video/Video.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMEvent"] */ "/app/src/features/google-tag-manager/components/GoogleTagManager.tsx");
